import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { PersonSearchRequest } from './PersonSearchRequest';
import { Pro } from './Pro';
import { Company } from './Company';
import { Gender } from '../common/Gender';

export class ArtistSearchRequest extends PersonSearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public proIds: string[] = [];
	public pros: Pro[] = [];
	public companyIds: string[] = [];
	public companies: Company[] = [];
	public genderIds: number[] = [];
	public genders: Gender[] = [];

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.proIds) {
			this.proIds = Array.isArray(init.proIds)
				? init.proIds
				: init.proIds.split(',');
		}
		if (init.companyIds) {
			this.companyIds = Array.isArray(init.companyIds)
				? init.companyIds
				: init.companyIds.split(',');
		}
		if (init.genderIds) {
			if (Array.isArray(init.genderIds)) {
				this.genderIds = init.genderIds;
			} else {
				const genders = init.genderIds.split(',');
				this.genderIds = genders.map((x) => parseInt(x, null));
			}
		}

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('artist-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as ArtistSearchRequest;
		if (!prevFilter) { return; }

		if (prevFilter?.pros?.length) {
			for (const id of this.proIds) {
				const found = prevFilter.pros.find((x) => x.id === id);
				if (found) { this.pros.push(found); }
			}
		}

		if (prevFilter?.companies?.length) {
			for (const id of this.companyIds) {
				const found = prevFilter.companies.find((x) => x.id === id);
				if (found) { this.companies.push(found); }
			}
		}

		if (prevFilter?.genders?.length) {
			for (const id of this.genderIds) {
				const found = prevFilter.genders.find((x) => x.id === id);
				if (found) { this.genders.push(found); }
			}
		}
	}

	public collapse(): any {
		const response = super.collapse();
		if (this.proIds?.length) { response.proIds = this.proIds.join(','); }
		if (this.genderIds?.length) { response.genderIds = this.genderIds.join(','); }
		if (this.companyIds?.length) { response.companyIds = this.companyIds.join(','); }
		return response;
	}

	public clear() {
		super.clear();
		this.companyIds = [];
		this.genderIds = [];
		this.proIds = [];
	}


}
